import {
  ClipboardListIcon,
  DeviceIcon,
  FemaleIcon,
  GaugeIcon,
  MaleFemaleIcon,
  MaleIcon,
  MonitorIcon,
  MonitorPhoneIcon,
  EraserIcon,
} from 'components/Icons';
import { TFunction } from 'i18next';

export const FIRST_VERSION = 1;

export const APP_WRAPPER_ID = 'app-wrapper-scrollable';

export const SECURITY_LOGOUT_MESSAGE = 'Security Logout';

export const DEFAULT_NO_OWNER_USER = {
  id: 'NO_OWNER',
  name: 'NOT ASSIGNED',
};

export const DEFAULT_ANOTHER_SOURCE_SALES_USER = {
  id: 'ANOTHER_SOURCE',
  name: 'ANOTHER_SOURCE',
  email: 'another_source@offerwise.com',
};

export const REGEX = {
  EMAIL: /^[\w-.]+@([\w-]+\.)+\w+$/i,

  NON_NUMERIC_GLOBAL: /\D/g,
  ALL_NUMERIC: /^\d$/g,

  /*
    https://www.regextester.com/96504
    This one was giving infinite loops if comments had ...a text like that
  */
  // LINK: /(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()[\]{};:'".,<>?«»“”‘’]))?/i,

  // https://regexr.com/39nr7
  LINK: /[(http(s)?)://(www.)?a-zA-Z0-9@:%._\-+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i,
};

export const CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD' },
  { value: 'ARS', label: 'ARS' },
  { value: 'BRL', label: 'BRL' },
  { value: 'COP', label: 'COP' },
  { value: 'CLP', label: 'CLP' },
  { value: 'EUR', label: 'EUR' },
  { value: 'MXN', label: 'MXN' },
  { value: 'PEN', label: 'PEN' },
];

export const CLIENT_ORIGIN_OPTIONS = [
  { value: 'Argentina', getLabel: (t: TFunction) => t('argentina') },
  { value: 'Africa', getLabel: (t: TFunction) => t('africa') },
  { value: 'Asia', getLabel: (t: TFunction) => t('asia') },
  { value: 'Bolivia', getLabel: (t: TFunction) => t('bolivia') },
  { value: 'Brazil', getLabel: (t: TFunction) => t('brazil') },
  { value: 'Canada', getLabel: (t: TFunction) => t('canada') },
  { value: 'Central America', getLabel: (t: TFunction) => t('central-america') },
  { value: 'Chile', getLabel: (t: TFunction) => t('chile') },
  { value: 'Colombia', getLabel: (t: TFunction) => t('colombia') },
  { value: 'Ecuador', getLabel: (t: TFunction) => t('ecuador') },
  { value: 'Europa', getLabel: (t: TFunction) => t('europa') },
  { value: 'Mexico', getLabel: (t: TFunction) => t('mexico') },
  { value: 'Oceania', getLabel: (t: TFunction) => t('oceania') },
  { value: 'Paraguay', getLabel: (t: TFunction) => t('paraguay') },
  { value: 'Peru', getLabel: (t: TFunction) => t('peru') },
  { value: 'US', getLabel: (t: TFunction) => t('us') },
  { value: 'Uruguay', getLabel: (t: TFunction) => t('uruguay') },
  { value: 'Venezuela', getLabel: (t: TFunction) => t('venezuela') },
];

export const PROJECT_TYPE_OPTIONS = [
  { value: 'AD_HOC', getLabel: (t: TFunction) => t('AD_HOC') },
  { value: 'COMMUNITY', getLabel: (t: TFunction) => t('COMMUNITY') },
  { value: 'FOCUS_GROUP', getLabel: (t: TFunction) => t('FOCUS_GROUP') },
  { value: 'DIY', getLabel: (t: TFunction) => t('DIY') },
  { value: 'DIARY', getLabel: (t: TFunction) => t('DIARY') },
  { value: 'HOSTING', getLabel: (t: TFunction) => t('HOSTING') },
  { value: 'IN_DEPTH_INTERVIEW', getLabel: (t: TFunction) => t('IN_DEPTH_INTERVIEW') },
  { value: 'IHUT', getLabel: (t: TFunction) => t('IHUT') },
  { value: 'OMNIBUS', getLabel: (t: TFunction) => t('OMNIBUS') },
  { value: 'QUALI_QUANTI', getLabel: (t: TFunction) => t('QUALI_QUANTI') },
  { value: 'TRACKER_ORIGIN', getLabel: (t: TFunction) => t('TRACKER_ORIGIN') },
  { value: 'TRACKER_SEQUENCE', getLabel: (t: TFunction) => t('TRACKER_SEQUENCE') },
];

export const DEVICE_OPTIONS = [
  {
    id: 'DESKTOP',
    sampleId: '0',
    getLabel: (t: TFunction) => t('desktop-only'),
    icon: MonitorIcon,
  },
  { id: 'MOBILE', sampleId: '2', getLabel: (t: TFunction) => t('mobile-only'), icon: DeviceIcon },
  {
    id: 'ALL_DEVICES',
    sampleId: '1',
    getLabel: (t: TFunction) => t('device-agnostic'),
    icon: MonitorPhoneIcon,
  },
];

export const SAMPLE_HOST_OPTIONS = [
  { sampleId: '1', getLabel: () => 'Offerwise' },
  { sampleId: '0', getLabel: (t: TFunction) => t('client') },
];

export const SAMPLE_GENDER_OPTIONS = [
  { sampleId: 'Both', getLabel: (t: TFunction) => t('both-genders'), Icon: MaleFemaleIcon },
  { sampleId: 'Male', getLabel: (t: TFunction) => t('male'), Icon: MaleIcon },
  { sampleId: 'Female', getLabel: (t: TFunction) => t('female'), Icon: FemaleIcon },
];

export const REPRICE_REASONS = [
  {
    value: 'PROJECT_SCOPE_CHANGE',
    getLabel: (t: TFunction) => t('PROJECT_SCOPE_CHANGE'),
    icon: ClipboardListIcon,
    getDescription: (t: TFunction) => t('PROJECT_SCOPE_CHANGE_description'),
  },
  {
    value: 'FIELD_METRICS_DIFFER_FROM_QUOTATION',
    getLabel: (t: TFunction) => t('FIELD_METRICS_DIFFER_FROM_QUOTATION'),
    icon: GaugeIcon,
    getDescription: (t: TFunction) => t('FIELD_METRICS_DIFFER_FROM_QUOTATION_description'),
  },
  {
    value: 'INCORRECT_INFO_FIX',
    getLabel: (t: TFunction) => t('INCORRECT_INFO_FIX'),
    icon: EraserIcon,
    getDescription: (t: TFunction) => t('INCORRECT_INFO_FIX_description'),
  },
];
